import React from 'react';
import Icon from '../../../components/AppIcon';

const ErrorMessage = ({ message, onRetry }) => {
  if (!message) return null;

  return (
    <div className="mt-4 p-4 bg-error/10 border border-error/20 rounded-lg">
      <div className="flex items-start gap-3">
        <Icon name="AlertCircle" size={20} color="var(--color-error)" className="flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm font-medium text-error mb-1">
            Authentication Failed
          </p>
          <p className="text-xs text-error/80 mb-3">
            {message}
          </p>
          {onRetry && (
            <button
              onClick={onRetry}
              className="text-xs font-medium text-error hover:text-error/80 underline focus-ring rounded"
            >
              Try again
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;